import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Row, Col, Typography } from 'antd';

import { LoadingScreen } from 'components';

// import BenchmarkAndFundPerformance from './BenchmarkAndFundPerformance';
import BenchmarkAndFundPerformance from './BenchmarkAndFundPerformanceApex';
import ReturnVsVolatility from './ReturnVsVolatility';

// import FundsPerformance from './FundsPerformance';
import FundsPerformance from './FundsPerformanceApex';
// import AllocationsVsBenchmark from './AllocationsVsBenchmark';

import { fetchMetrics, selectors } from 'state';
import LeaderBoard from './LeaderBoard';
import Biases from './Biases';
// import MinimumReserveRequiredGraph from './MinimumReserveRequiredGraph';
import MinimumReserveRequiredGraph from './MinimumReserveRequiredGraphApex';

const Performance: React.FC = () => {
  const dispatch = useDispatch();
  const {
    metrics_fetched,
    metrics_fetching,
    id,
    client_money,
    allow_individual_benchmark,
  } = useSelector(selectors.activeSession);

  console.log(metrics_fetched);
  console.log(metrics_fetching);

  useEffect(() => {
    console.log(metrics_fetched);
    console.log('before return');

    if (metrics_fetched) return;
    console.log('after return');
    dispatch(fetchMetrics({ session_id: id }));
    // TODO: this gets triggered every historical time pass
    //  bc. metrics_fetched and metrics_fetching dissapear from session state.
    //  just handle metrics_fetched and metrics_fetching appropriately and update stuff over ws
  }, [dispatch, metrics_fetched]);

  if (metrics_fetching || !metrics_fetched) return <LoadingScreen />;

  return (
    <div>
      <Row gutter={80}>
        <Col span={16}>
          <Row>
            <Col span={18}>
              <Typography.Title level={4}>Funds Performance</Typography.Title>
              <Typography.Text>
                Click on legend to activate / deactivate values
              </Typography.Text>
              <FundsPerformance />
            </Col>
          </Row>
          <Row>
            <Col span={18}>
              <Typography.Title level={4}>
                Return vs Volatility
              </Typography.Title>
              <ReturnVsVolatility />
            </Col>
          </Row>
          <Row>
            <Col span={18} style={{ height: 620 }}>
              <Typography.Title level={4}>
                Benchmark and Fund Performance
              </Typography.Title>
              <Typography.Text>
                Allow individual benchmarks:{' '}
                {allow_individual_benchmark ? 'True' : 'False'}
              </Typography.Text>
              {/*CHANGED FROM HIGHCHARTS TO APEXCHARTS*/}
              <BenchmarkAndFundPerformance />
            </Col>
          </Row>
          {client_money && (
            <Row>
              <Col span={18} style={{ height: 620 }}>
                <Typography.Title level={4}>
                  Minimum Reserve Required
                </Typography.Title>
                {/*CHANGED FROM HIGHCHARTS TO APEXCHARTS*/}
                <MinimumReserveRequiredGraph />
              </Col>
            </Row>
          )}
        </Col>
        <Col
          span={8}
          style={{
            // minWidth: 400,
            borderLeft: '2px solid #eeeeee',
            display: 'flex',
            flexDirection: 'column',
            // gap: 30,
          }}
        >
          <LeaderBoard />
          <br />
          <br />
          {/*<Biases />*/}
        </Col>
      </Row>

      {/*<Row>*/}
      {/*  <Col span={18}>{<AllocationsVsBenchmark />}</Col>*/}
      {/*</Row>*/}
    </div>
  );
};

export default Performance;
